import { render, staticRenderFns } from "./SkuTaskDetail.vue?vue&type=template&id=39cb4dfb"
import script from "./SkuTaskDetail.vue?vue&type=script&lang=js"
export * from "./SkuTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports